import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import s from "../modules/Login.module.css";
import { useT, useI18nReady } from "../components/TextProvider";

// ← ЗАМЕНИ на реальный эндпоинт регистрации
const REGISTER_ENDPOINT =
  process.env.REACT_APP_REGISTER_ENDPOINT ||
  "https://apitr.subxonqulov.uz/api/v1/dj-rest-auth/registration/";

const LOGIN_ROUTE = "/login"; // куда редиректить после регистрации

export default function Register() {
  const navigate = useNavigate();

      const t = useT();
      const ready = useI18nReady();

  const [username, setUsername] = useState("");
  const [mail, setMail] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!username.trim() || !mail.trim() || !pwd || !pwd2) {
      setError("Iltimos, barcha maydonlarni toʻldiring.");
      return;
    }
    if (pwd !== pwd2) {
      setError("Parollar mos kelmayapti.");
      return;
    }

    try {
      setLoading(true);

      const body = {
        username: username.trim(),
        email: mail.trim(),
        password1: pwd,
        password2: pwd2,
      };

      const res = await fetch(REGISTER_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          data?.detail ||
          data?.error ||
          data?.message ||
          (data && Object.values(data)[0]) ||
          "Ro'yxatdan o'tishda xatolik.";
        throw new Error(Array.isArray(msg) ? msg.join(" ") : String(msg));
      }

      // Успешно → переходим на логин
      navigate(LOGIN_ROUTE, { replace: true });
    } catch (err) {
      setError(err?.message || "Ro'yxatdan o'tishda xatolik yuz berdi.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={s.wrapper}>
      <div className={s.card}>
        <h1 className={s.title}>{t('ruyxatdanUtish')}</h1>

        <form className={s.form} onSubmit={handleSubmit} noValidate>
          {/* Username */}
          <div className={s.field}>
            <input
              className={s.input}
              type="text"
              placeholder=" "
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <span className={s.label}>{t('foydalanuchiNomi')}</span>
          </div>

          {/* Email */}
          <div className={s.field}>
            <input
              className={s.input}
              type="email"
              placeholder=" "
              value={mail}
              onChange={(e) => setMail(e.target.value)}
              required
            />
            <span className={s.label}>{t('pochta')}</span>
          </div>

          {/* Пароль */}
          <div className={s.field}>
            <input
              className={s.input}
              type="password"
              placeholder=" "
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              required
            />
            <span className={s.label}>{t('parol')}</span>
          </div>

          {/* Подтверждение пароля */}
          <div className={s.field}>
            <input
              className={s.input}
              type="password"
              placeholder=" "
              value={pwd2}
              onChange={(e) => setPwd2(e.target.value)}
              required
            />
            <span className={s.label}>{t('parolnitakrorlang')}</span>
          </div>

          {error && <div className={s.error}>{error}</div>}

          <button
            className={s.submit}
            type="submit"
            disabled={loading || !username || !mail || !pwd || !pwd2}
          >
            {loading ? "Ro'yxatdan o'tmoqdasiz…" : "Ro'yxatdan o'tish"}
          </button>
        </form>

        <div className={s.footer}>
          {t('bormi')}{" "}
          <Link to="/login" className={s.link}>
            {t('kirish')}
          </Link>
        </div>
      </div>
    </div>
  );
}
